import apiClient from "./axios";

const BASE_PATH = "/v3/schedule/tags";

export const scheduleTagApi = {
    list: ({ includeInactive = false } = {}) =>
        apiClient.get(BASE_PATH, {
            params: { include_inactive: includeInactive },
        }),
    create: (data) => apiClient.post(BASE_PATH, data),
    update: (tagId, data) => apiClient.patch(`${BASE_PATH}/${tagId}`, data),
};

export default scheduleTagApi;
